// External Dependencies:
import React from 'react'

class Text extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			hasError: false
		}
	}

	static defaultProps = {
		type: 'text',
		handleError: false
	}

	handleChange = ( e ) => {
		this.validate( e.target.value )

		this.props.onChange( this.props.id, e.target.value )
	}

	handleError = ( e ) => {
		this.props.handleError( this.props.id, hasError )
	}

	validate = ( value ) => {
		var hasError = false

		switch( this.props.type ) {
			case 'email':
				hasError = ! value.match( /\S+@\S+\.\S+/ )

				break

			default:
				return
		}

		this.setState( {
			hasError: hasError
		})

		if ( this.props.handleError ) {
			this.props.handleError( this.props.id, hasError )
		}
	}

	render() {
		const { id, label, value, type } = this.props
		const { hasError } = this.state
		let className = hasError ? 'form-item form-text has-error' : 'form-item form-text'

		if ( type ) {
			className += ' form-' + type
		}

		return (
			<div className={ className }>
				<label htmlFor={ id } dangerouslySetInnerHTML={ { __html: label } } />

				<input type={ type } name={ id } value={ value } onChange={ this.handleChange } />

				<i className="icon-dke-close" aria-hidden="true"></i>
			</div>
		)
	}
}

export default Text



// WEBPACK FOOTER //
// ./components/form/text.jsx